// extracted by mini-css-extract-plugin
export default {"modal":"SuggestedFriends--modal--XhSxW","modal-actions":"SuggestedFriends--modal-actions--H4hL3","modalActions":"SuggestedFriends--modal-actions--H4hL3"};